export enum CharonRelation {
  LIKERT_LIST = 'likert_reviews',
  SESSION = 'sessions'
}

export enum CharonHeaders {
  AUTHORIZATION = 'Authorization',
  CORRELATION_ID = 'x-itau-correlationID',
  PARAMS = 'x-charon-params',
  SESSION = 'X-Charon-Session',
  APIKEY = 'x-itau-apikey'
}
